export default "__VITE_ASSET__CPsOkfCz__"